import { render, staticRenderFns } from "./UserProfileAccount.vue?vue&type=template&id=6ac15fc8&scoped=true"
import script from "./UserProfileAccount.vue?vue&type=script&lang=js"
export * from "./UserProfileAccount.vue?vue&type=script&lang=js"
import style0 from "./UserProfileAccount.vue?vue&type=style&index=0&id=6ac15fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac15fc8",
  null
  
)

export default component.exports